import { removeNullElements } from "../commons"

export default (state, indexes) => {
  let { currentEditMessage, currentEditSlidePage } = state
  const { rowIndexDetail, slidePageIndex } = indexes // Index for group component slide page
  const editTargetFlag = slidePageIndex || slidePageIndex === 0 && rowIndexDetail || rowIndexDetail === 0 && currentEditSlidePage
  const editState = editTargetFlag ? 'SLIDE_PAGE' : 'MESSAGE'
  let editTarget = editTargetFlag ? [currentEditSlidePage] : currentEditMessage
  /**
   * Index 요소 관련
   * message_index는 참조 기준(0부터)으로 잡혀있음
   * row_index, component_index는 사용자 기준(1부터)으로 잡혀있음
   */
  const { message_index_dragged, row_index_dragged, component_index_dragged } = indexes // Dragged component (source)
  const message_index_dragged_calc = editTargetFlag ? 0 : message_index_dragged // For group slide page
  const row_index_dragged_calc = editTargetFlag ? rowIndexDetail : row_index_dragged // For group slide page
  // const row_index_target_calc = editTargetFlag ? row_index_target : row_index_target // For group slide page
  editTarget = editTarget.map((message, i) => {
    if (i === message_index_dragged_calc) {
      let { rows } = message

      if (!rows) {
        console.error('target rows가 존재하지 않아 컴포넌트를 삭제하지 못하였음 rows => ', rows)
        return message
      }
      
      rows = rows.map((row, i) => {
        if (i === row_index_dragged_calc) {
          let { components } = row

          if (!components) {
            console.error('target components가 존재하지 않아 컴포넌트를 삭제하지 못하였음 components => ', components)
            return row
          }

          components = components.filter((component, i) => i !==component_index_dragged)
          // console.log('Filtered components => ', components)
          if (components.length <= 0) {
            return null
          }
          return {
            ...row,
            components: components,
          }
        }
        return row
      })
      rows = removeNullElements(rows)
      // if (rows.length <= 0) {
      //   return null
      // }
      return {
        ...message,
        rows: rows
      }
    }
    return message
  })
  /**
   * 아무런 값이 없을 경우 message도 삭제
   */
  // editTarget = removeNullElements(editTarget)

  if (editTargetFlag) {
    return {
      editState: editState,
      result: editTarget[0],
    }
  }
  return {
    editState: editState,
    result: editTarget,
  }
}